import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InteractionFilter, TimeFilterTypes} from '../../../../shared/types/nso-data-portal/interaction-data';

@Component({
  selector: 'wsd-interaction-search',
  templateUrl: './interaction-search.component.html',
  styleUrls: ['./interaction-search.component.css']
})
export class InteractionSearchComponents {

  @Input()
  filter: InteractionFilter;

  @Output()
  search = new EventEmitter<any>();

  timeFilters = TimeFilterTypes;

  constructor() { }

}
